<template>
  <div id="home-view">
    <div class="uploads">
      <div class="upload-files" v-if="!generatedTable">
        <upload-product-update-template />
        <upload-book-keeping-file />
      </div>

      <div v-if="!generatedTable" class="table-generation-controls">
        <div v-if="!generatingTable && !generatedTable">
          <v-btn
            id="generate-table-btn"
            :disabled="generatingTable"
            color="primary"
            @click="generateTable()"
            large
          >
            Generate table
          </v-btn>
        </div>
        <div v-if="generatingTable" class="generating-table-msg generating-table-msg-in-progress">
          <span>Generating Table..</span>
        </div>
        <div v-if="tableGenerationError" class="generating-table-msg error-msg">
          <span>Error generating table</span>
        </div>
      </div>
    </div>

    <summary-report-table ref="summaryReport" />

    <v-divider class="my-10 grey lighten-1" v-show="generatedTable"></v-divider>

    <details-table ref="detailsTable" />

    <div id="summary-table-window-portal-container" v-if="receivedSummaryReportTable && summaryReportTableWindowOpen">
      <WindowPortal title="Summary Report" :open="summaryReportTableWindowOpen" compName="summary-report-table" :compRef="$refs.summaryReport" />
    </div>

    <div id="details-table-window-portal-container" v-if="generatedTable && productsDetailsTableWindowOpen">
      <WindowPortal title="Products Details" :open="productsDetailsTableWindowOpen" compName="details-table" :compRef="$refs.detailsTable" />
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';

import UploadProductUpdateTemplate from '../components/UploadProductUpdateTemplate';
import UploadBookKeepingFile from '../components/UploadBookKeepingFile';
import SummaryReportTable from '../components/SummaryReportTable';
import DetailsTable from '../components/DetailsTable';
import WindowPortal from '../components/WindowPortal';

export default {
  data() {
    return {};
  },
  components: {
    UploadProductUpdateTemplate,
    UploadBookKeepingFile,
    WindowPortal,
    SummaryReportTable,
    DetailsTable,
  },
  computed: {
    ...mapState('products', [
      'generatingTable',
      'generatedTable',
      'tableGenerationError',
      'summaryReportOpened',
      'receivedSummaryReportTable',
      'summaryReportTableWindowOpen',
      'productsDetailsTableWindowOpen'
    ]),
  },
  methods: {
    generateTable() {
      this.$store.dispatch('products/generateTable', localStorage.getItem('selectedLocationId'));
    },
  },
};
</script>


<style>

.error-msg {
  color: #cf0436;
  font-size: 14pt;
}

.upload-file-section {
  margin-bottom: 30px;
}

.upload-file-section h2 {
  margin-top: 0;
  margin-bottom: 12px;
}

.upload-btns-group {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.btn-upload:hover {
  cursor: pointer;
}

#generate-table-btn {
  margin-bottom: 10px;
}

#table-saving-error {
  margin-top: 15px;
  font-size: 14pt;
}

.generating-table-msg {
  font-size: 14pt;
  width: 100%;
}

.generating-table-msg-in-progress {
  margin-top: 10px;
}

.table-generation-controls {
  margin-top: 40px;
  /*
  display: flex;
  align-items: center;
  */
}

.v-card {
  box-shadow: rgb(67 71 85 / 37%) 0.02em 0.1em 0.4em !important;
}

</style>



// WEBPACK FOOTER //
// src/views/Home.vue